import './styles/NotFound.css'
export default function NotFound(props) {
    return (
        <div className="error-page-wrapper">
            <div className="background  flx-row flx-all-center flx-jst-center">
            <div className="col">
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
            </div>
            <div className="col">
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
            </div>
            <div className="col">
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
            </div>
            <div className="col">
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
            </div>
            <div className="col">
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
            </div>
            <div className="col">
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
            </div>
            <div className="col">
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
            </div>
            <div className="col">
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
                <span>0</span>
            </div>
            <div className="col">
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
                <span>4</span>
            </div>
            </div>
            <div className="box">
                <h1>La page n'a pas été trouvée</h1>
                <p>Malheureusement, la page que vous cherchez n'existe pas. <span>Mais voici quelque pages qui pourraient vous interesser :</span></p>
                <div className="link-list">
                    <a href="/">Accueil</a>
                    <a href="/">Projets</a>
                    <a href="/">Contact</a>
                </div>
            </div>
        </div>
    );
};